/**
 * True when the card deck is a single column (detail should open under the tapped card).
 */

import { useEffect, useState } from 'react';

export function useStackedCardDeckLayout(maxWidthPx: number): boolean {
  const query = `(max-width: ${maxWidthPx}px)`;

  const [stacked, setStacked] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setStacked(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return stacked;
}
